import type { TDatadogErrorLog } from 'utils/datadog/types'

export const PARSE_QUERY_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/niche-card/niche-card.model.ts',
  name: 'Failed to parse territory query',
  message: 'Error occurred while parsing territory query',
}
